<ul class="menu-items p-t-25" [perfectScrollbar]="config" [disabled]="isPerfectScrollbarDisabled">
    <div *ngFor="let item of menuItems">
        <a *ngIf="item.routerLink" [ngClass]="{'active-link':isActive(item.routerLink)}" [routerLink]="item.routerLink" class="sidebar-link clickable">
            <li (click)="toggleNavigationSub($event,item);">
				<pg-menu-icon *ngIf="item.iconType" [IconType]="item.iconType" [IconName]="item.iconName" [ExtraClass]="item.thumbNailClass"></pg-menu-icon>

                <a class="menu-link-item" *ngIf="item.submenu;else singleLink" [class.detailed]="item.details">
                    <span class="title">{{ item.label }}</span>
                    <span  *ngIf="item.details" class="details">{{item.details}}</span>
                    <span  *ngIf="item.submenu" class=" arrow" [class.open]="item.toggle ==='open'"></span>
                </a>
                <ng-template #singleLink>
                <a class="menu-link-item" *ngIf="item.routerLink" [class.detailed]="item.details">
                    <span class="title">{{ item.label }}</span>
                    <span  *ngIf="item.details" class="details">{{item.details}}</span>
                </a>
                <a class="menu-link-item" *ngIf="item.externalLink" href="{{item.externalLink}}" [attr.target]="item.target" [class.detailed]="item.details">
                    <span class="title">{{ item.label }}</span>
                    <span  *ngIf="item.details" class="details">{{item.details}}</span>
                </a>
                </ng-template>
                
            </li>
        </a>

        <a *ngIf="!item.routerLink && item.submenu && item.submenu[0]" [ngClass]="{'active-link':childIsActive(item)}" class="sidebar-link clickable">
            <li (click)="toggleNavigationSub($event,item);">
                <pg-menu-icon *ngIf="item.iconType" [IconType]="item.iconType" [IconName]="item.iconName" [ExtraClass]="item.thumbNailClass"></pg-menu-icon>

                <a class="menu-link-item" *ngIf="item.submenu;else singleLink" [class.detailed]="item.details">
                    <span class="title">{{ item.label }}</span>
                    <span  *ngIf="item.details" class="details">{{item.details}}</span>
                    <span  *ngIf="item.submenu" class=" arrow" [class.open]="item.toggle ==='open'"></span>
                </a>

                <ng-template #singleLink>
                <a class="menu-link-item" *ngIf="item.routerLink" [class.detailed]="item.details">
                    <span class="title">{{ item.label }}</span>
                    <span  *ngIf="item.details" class="details">{{item.details}}</span>
                </a>
                <a class="menu-link-item" *ngIf="item.externalLink" href="{{item.externalLink}}" [attr.target]="item.target" [class.detailed]="item.details">
                    <span class="title">{{ item.label }}</span>
                    <span  *ngIf="item.details" class="details">{{item.details}}</span>
                </a>
                </ng-template>
            </li>
    
            <ul class="sub-menu" *ngIf="item.submenu" [@toggleHeight]="item.toggle">

                <a *ngFor="let child of item.submenu" (click)="openLink(item)" [routerLink]="child.routerLink" [queryParams]="child.URLSearchParams">
                    <pg-menu-icon *ngIf="child.iconType" [IconType]="child.iconType" [IconName]="child.iconName"></pg-menu-icon>

                    <li [class.open]="child.toggle ==='open'" [ngClass]="{'active-link-sub':isActive(child.routerLink,true)}">
                        <a href="javascript:;" *ngIf="child.submenu;else singleLinkChild" (click)="toggleNavigationSub($event,item)"><span class="title">{{ child.label }}</span>
                            <span  *ngIf="child.submenu" class=" arrow" [class.open]="item.toggle ==='open'"></span>
                        </a>

                        <ng-template #singleLinkChild>
                        <a *ngIf="child.routerLink" ><span class="title">{{ child.label }}</span>
                        </a>
                        <a *ngIf="child.externalLink" href="{{child.externalLink}}" [attr.target]="item.target"><span class="title">{{ child.label }}</span>
                        </a>
                        </ng-template>
                        <ul class="sub-menu" *ngIf="child.submenu" [@toggleHeight]="child.toggle">
                            <li *ngFor="let lvl2 of child.submenu">
                                <a *ngIf="lvl2.routerLink" routerLinkActive="active-link"><span class="title">{{ lvl2.label }}</span>
                                    <span  *ngIf="lvl2.submenu" class=" arrow" [class.open]="lvl2.toggle"></span>
                                </a>
								<pg-menu-icon *ngIf="lvl2.iconType" [IconType]="lvl2.iconType" [IconName]="lvl2.iconName"></pg-menu-icon>
                                <a *ngIf="lvl2.externalLink" routerLinkActive="active-link"><span class="title">{{ item.label }}</span></a>
                                
                            </li>
                        </ul>
                    </li>
                </a>
            </ul>
        </a>
    </div>
</ul>